import React from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '@material-ui/core/LinearProgress';

import ReportCard from "../utils/ReportCard";

const styles = theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  },
    progress: {
        marginBottom: 20,
    }
});

class Reports extends React.Component {

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
          <div>
          {this.props.loading && (
            <div className={this.props.classes.progress}>
                <LinearProgress />
            </div>
            )}
              <Typography variant="display1" gutterBottom>
                {this.props.reports.length + " rapports à traiter "}
                <Tooltip title="Les rapports ayant un rendez-vous (n'inclut pas les audits rejeté ou validé)"><InfoIcon /></Tooltip>
              </Typography>
              <Grid container spacing={24} >
                {this.props.reports.map(report => (
                  <Grid item key={report.id} xs={12} sm={6} md={6} lg={3} >
                    <ReportCard report={report} />
                  </Grid>
                ))}
              </Grid>
            </div>

      </React.Fragment>
    );
  }
}

Reports.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Reports);



// WEBPACK FOOTER //
// ./src/component/report/reports.js